<!-- ================首页-已发布备课详情====================-->
<template>
    <div class="tea-release-lesson-info-page">
        <home-head />
        <div class="tea-release-lesson-body">
            <div class="tea-release-lesson-inner" v-loading="loading">
                <!-- 标题区 -->
                <div class="page-header">
                    <div class="page-title-box">
                        <div class="page-title">已发布备课详情</div>
                        <div class="page-subtitle">{{ lessonInfo.title || '--' }}</div>
                    </div>
                    <div class="page-actions">
                        <div class="back-btn" @click="goBack">
                            <span>返回列表</span>
                        </div>
                    </div>
                </div>

                <!-- 基本信息 -->
                <div class="info-section">
                    <div class="section-header">
                        <div class="section-title-group">
                            <div class="section-title">基本信息</div>
                            <div class="info-status-bar">
                                <span class="status-tag status-end">已发布</span>
                            </div>
                        </div>
                    </div>
                    <div class="base-info-content">
                        <div class="info-main">
                            <div class="info-title">[已发布备课]{{ lessonInfo.title || '--' }}</div>
                            <div class="info-row">
                                <span class="info-label">学科信息：</span>
                                <span class="info-value">{{ lessonInfo.periodName || '--' }}、{{ lessonInfo.gradeName || '--' }}、{{ lessonInfo.subjectName || '--' }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">备课级别：</span>
                                <span class="info-value">{{ lessonInfo.lessonLevelName || '--' }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">备课时段：</span>
                                <span class="info-value">{{ formatTimeRange(lessonInfo) }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.discussMode !== 0">
                                <span class="info-label">备课研讨：</span>
                                <span class="info-value">{{ formatDiscussMode(lessonInfo.discussMode) }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">主备人：</span>
                                <span class="info-value">{{ lessonInfo.leadUserName || '--' }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.teamUserNames || teamUserText">
                                <span class="info-label">协备人：</span>
                                <span class="info-value">{{ lessonInfo.teamUserNames || teamUserText || '--' }}</span>
                            </div>
                            <div class="info-row" v-if="lessonInfo.guideNames || guideUserText">
                                <span class="info-label">指导专家：</span>
                                <span class="info-value">{{ lessonInfo.guideNames || guideUserText || '--' }}</span>
                            </div>
                            <div class="info-row">
                                <span class="info-label">完成时间：</span>
                                <span class="info-value">{{ lessonInfo.finishTime ? timestampToTime(lessonInfo.finishTime) : '--' }}</span>
                            </div>
                        </div>
                        <div class="info-cover">
                            <img class="img-100" :src="lessonInfo.coverUrl || defaultCover" alt="备课封面" />
                        </div>
                    </div>
                </div>

                <!-- 附件资料（共案） -->
                <div class="info-section">
                    <div class="section-title" style="margin-bottom: 16px;">附件资料</div>
                    <div class="attachment-container" v-if="hasGaFiles">
                        <!-- 共案 -->
                        <div class="attachment-block">
                            <div class="block-title">共案</div>
                            <template v-for="field in gaFileFields" :key="field.key">
                                <div class="file-type-block" v-if="lessonInfo[field.field] && lessonInfo[field.field].length > 0">
                                    <div class="file-type-label">{{ field.label }}</div>
                                    <div class="file-list">
                                        <div class="file-item" v-for="item in lessonInfo[field.field]" :key="item.fileId">
                                            <span class="file-name" :title="item.fileName">{{ item.fileName }}</span>
                                            <div class="file-actions">
                                                <span class="file-action" @click="viewFile(item)">预览</span>
                                                <span class="file-action" @click="handleDownloadFile(item)">下载</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!-- 暂无附件 -->
                    <div class="empty-attachment" v-else>
                        <div class="empty-icon">
                            <img src="@/assets/image/data_empty.png" alt="暂无附件" />
                        </div>
                        <div class="empty-text">暂无附件</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 附件预览 -->
        <el-image-viewer
            v-if="previewVisible"
            :url-list="previewSrcList"
            :initial-index="0"
            :hide-on-click-modal="true"
            @close="previewVisible = false"
        />
    </div>
</template>

<script>
import { lessonInfo } from "@/api/admin/lesson";
import { timestampToTime } from "@/utils/date";
import { downloadFile } from "@/utils/download";
import homeHead from "@/components/common/homeHead.vue";
import { ElImageViewer } from "element-plus";

export default {
    components: { homeHead, ElImageViewer },
    name: "teaReleaseLessonInfo",
    data() {
        return {
            timestampToTime,
            loading: false,
            lessonId: "",
            defaultCover: require("@/assets/logo/logo.png"),
            lessonInfo: {
                title: "",
                periodName: "",
                gradeName: "",
                subjectName: "",
                lessonLevelName: "",
                discussMode: 1,
                leadUserName: "",
                teamUserNames: "",
                guideNames: "",
                beginTime: "",
                endTime: "",
                finishTime: "",
                coverUrl: "",
                gajaFiles: [],
                gaxaFiles: [],
                gakjFiles: [],
                gaxtFiles: [],
                teamUserList: [],
                guideUserList: [],
            },
            gaFileFields: [
                { key: "gaja", field: "gajaFiles", label: "教案" },
                { key: "gaxa", field: "gaxaFiles", label: "学案" },
                { key: "gakj", field: "gakjFiles", label: "课件" },
                { key: "gaxt", field: "gaxtFiles", label: "习题" },
            ],
            // 附件预览
            previewVisible: false,
            previewSrcList: [],
        };
    },
    computed: {
        teamUserText() {
            if (this.lessonInfo.teamUserNames) return "";
            const list = (this.lessonInfo.teamUserList || []).map(e => e.trueName || e.expertName || "");
            return list.join("、");
        },
        guideUserText() {
            if (this.lessonInfo.guideNames) return "";
            const list = (this.lessonInfo.guideUserList || []).map(e => e.trueName || e.expertName || "");
            return list.join("、");
        },
        hasGaFiles() {
            return this.gaFileFields.some(f => this.lessonInfo[f.field] && this.lessonInfo[f.field].length > 0);
        },
    },
    created() {
        if (this.$route.query.lessonId) {
            this.lessonId = this.$route.query.lessonId;
            this.queryLessonInfo();
        }
    },
    mounted() {
        document.documentElement.classList.add("tea-release-lesson-scroll");
        document.body.classList.add("tea-release-lesson-scroll");
    },
    beforeUnmount() {
        document.documentElement.classList.remove("tea-release-lesson-scroll");
        document.body.classList.remove("tea-release-lesson-scroll");
    },
    methods: {
        /* ===============查询备课信息===================== */
        queryLessonInfo() {
            this.loading = true;
            lessonInfo({ lessonId: this.lessonId }).then(res => {
                if (res.data && res.data.code === 1) {
                    const data = res.data.data || {};
                    this.lessonInfo = { ...this.lessonInfo, ...data };
                } else {
                    this.$message.error(res.data.msg || "获取备课信息失败");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },

        /* ===============工具方法===================== */
        formatTimeRange(row) {
            if (row.beginTime && row.endTime) {
                return timestampToTime(row.beginTime) + " 至 " + timestampToTime(row.endTime);
            }
            return "--";
        },
        formatDiscussMode(val) {
            if (val == 1) return "一轮研讨";
            if (val == 2) return "二轮研讨";
            return "--";
        },

        /* ===============跳转===================== */
        goBack() {
            this.$router.push({ path: "/tea/teaResearch", query: { tab: "published" } });
        },

        /* ===============附件预览/下载===================== */
        handleDownloadFile(item) {
            downloadFile(item.fileUrl, item.fileName);
        },
        viewFile(item) {
            if (item.status !== 1) {
                this.$message.info("文件正在处理，请稍后刷新预览");
                return;
            }
            const previewList = this.gainFileImgList(item.imgUrl, item.pages);
            if (previewList && previewList.length > 0) {
                this.previewSrcList = previewList;
                this.previewVisible = true;
            } else if (item.fileUrl) {
                window.open(item.fileUrl, "_blank");
            } else {
                this.$message.info("暂无可预览内容");
            }
        },
        gainFileImgList(baseUrl, page) {
            const list = [];
            for (let i = 1; i <= page; i++) {
                list.push(baseUrl + "/" + i + ".png");
            }
            return list;
        },
    },
};
</script>

<style scoped>
.tea-release-lesson-info-page {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    overflow-y: auto !important;
}

.tea-release-lesson-body {
    flex: 1;
    width: 100%;
    height: 100%;
    background-color: #fdfcf8;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 30px 0 80px 0;
    box-sizing: border-box;
    overflow-y: auto !important;
}

.tea-release-lesson-body::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.tea-release-lesson-body::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 6px;
}

.tea-release-lesson-body::-webkit-scrollbar-thumb {
    background: #b22222;
    border-radius: 6px;
    border: 3px solid #f1f1f1;
}

.tea-release-lesson-body::-webkit-scrollbar-thumb:hover {
    background: #9a1b1b;
}

.tea-release-lesson-inner {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px 50px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* 标题区 */
.page-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.page-title-box {
    display: flex;
    flex-direction: column;
}

.page-title {
    font-size: 24px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    letter-spacing: 2px;
    margin-bottom: 6px;
}

.page-subtitle {
    font-size: 14px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

.page-actions {
    display: flex;
    align-items: center;
}

.back-btn {
    height: 36px;
    line-height: 36px;
    padding: 0 32px;
    background-color: #b22222;
    color: #ffffff;
    border-radius: 4px;
    font-size: 14px;
    font-family: sans-serif;
    cursor: pointer;
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
}

.back-btn:hover {
    background-color: #9a1b1b;
}

/* 信息区块 */
.info-section {
    width: 100%;
    background-color: #ffffff;
    border-radius: 4px;
    border: 1.5px solid #b22222;
    padding: 20px;
    box-sizing: border-box;
}

.section-title {
    font-size: 16px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    flex-shrink: 0;
}

.section-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f3f4f6;
    margin-bottom: 16px;
}

.section-title-group {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

/* 基本信息 */
.base-info-content {
    width: 100%;
    display: flex;
    gap: 20px;
}

.info-main {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.info-status-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}

.status-tag {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 13px;
    font-size: 12px;
    color: #ffffff;
    font-family: sans-serif;
    background-color: #4095e5;
}

.status-tag.status-end {
    background-color: #81b337;
}

.info-title {
    font-size: 18px;
    color: #1f2937;
    font-weight: bold;
    font-family: sans-serif;
    line-height: 1.5;
    margin-bottom: 8px;
}

.info-row {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    font-family: sans-serif;
    line-height: 1.6;
}

.info-label {
    color: #4b5563;
    white-space: nowrap;
}

.info-value {
    color: #1f2937;
    flex: 1;
    word-break: break-all;
}

.info-cover {
    width: 300px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    background-color: #f3f4f6;
}

.info-cover img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* 附件 */
.attachment-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.attachment-block {
    width: 100%;
    border: 1px solid #f3f4f6;
    border-radius: 4px;
    padding: 14px;
    box-sizing: border-box;
}

.block-title {
    font-size: 15px;
    color: #b22222;
    font-weight: bold;
    font-family: sans-serif;
    margin-bottom: 12px;
}

.file-type-block {
    margin-bottom: 12px;
}

.file-type-block:last-child {
    margin-bottom: 0;
}

.file-type-label {
    font-size: 13px;
    color: #4b5563;
    font-family: sans-serif;
    margin-bottom: 8px;
    padding-left: 8px;
    border-left: 3px solid #b22222;
}

.file-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background-color: #f9fafb;
    border-radius: 4px;
}

.file-name {
    font-size: 13px;
    color: #1f2937;
    font-family: sans-serif;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.file-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.file-action {
    font-size: 13px;
    color: #b22222;
    font-family: sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
}

.file-action:hover {
    color: #9a1b1b;
    text-decoration: underline;
}

.empty-attachment {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 0;
}

.empty-icon {
    width: 120px;
    height: 120px;
    margin-bottom: 16px;
}

.empty-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.empty-text {
    font-size: 15px;
    color: #9ca3af;
    font-family: sans-serif;
    letter-spacing: 1px;
}

/* 响应式 */
@media (max-width: 1024px) {
    .base-info-content {
        flex-direction: column;
    }

    .info-cover {
        width: 100%;
        max-height: 300px;
    }
}

@media (max-width: 768px) {
    .page-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .info-section {
        padding: 14px;
    }

    .file-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
}
</style>

<style>
html.tea-release-lesson-scroll,
body.tea-release-lesson-scroll {
    scrollbar-width: none;
    -ms-overflow-style: none;
}

html.tea-release-lesson-scroll::-webkit-scrollbar,
body.tea-release-lesson-scroll::-webkit-scrollbar {
    display: none;
}
</style>
